module.exports = __webpack_public_path__ + "img/money-managment-icon.14cd7d14.svg";